// Services
import callAPI from "../callApi";
import path from "../variables";

const turnover = {
	getAll: (filter: any) =>
		callAPI(
			"GET",
			`${path.base}/report/turnover-stats${filter ? filter : ""}`,
			"",
			"getting global stats"
		),

	getTicketOfficeTurnover: (filter: any) =>
		callAPI(
			"GET",
			`${path.base}/report/ticket-office/daily-ticket-turnover-for-current-user${
				filter ? filter : ""
			}`,
			"",
			"getting ticket office turnover for current user"
		),

	getParcelOfficeTurnover: (filter: any) =>
		callAPI(
			"GET",
			`${path.base}/report/parcel-office/daily-parcel-turnover-for-current-user${
				filter ? filter : ""
			}`,
			"",
			"getting ticket office turnover for current user"
		),
	getMonthlyByPriod: (filter: any) =>
		callAPI(
			"GET",
			`${path.base}/report/monthly-stats-by-period${filter ? filter : ""}`,
			"",
			"getting monthly turnover stats by period(months)"
		),
};

export default turnover;
